// import { WizardConfig, WizardConfigArgs } from './types'
import { CheckInWizardStep } from './constants'
import { GetStarted } from './components/GetStarted'
import { WizardConfig, WizardConfigArgs } from './types'
import { ReviewPreviousPriorities } from './components/ReviewPreviousPriorities'
import { RevisitYourBaselines } from './components/RevisitYourBaselines'
import { YourOrgMissionImpact } from './components/YourOrgMissionImpact'
import { YourOrgHealth } from './components/YourOrgHealth'
import { ThankYou } from './components/ThankYou'

const {
  GET_STARTED,
  REVIEW_PREVIOUS_PRIORITIES,
  REVISIT_YOUR_BASELINES,
  YOUR_ORG_MISSION_IMPACT,
  YOUR_ORG_HEALTH,
  THANK_YOU,
} = CheckInWizardStep

/*
  This config is used to create the various steps for the Check-In Survey wizard.
  Each step is passed a custom component to render, and any additional configuration needed.
  All the handlers and values that each step needs are passed from the parent state.
 */
export const createWizardConfig = ({
  checkInSurveyComments,
  onAnyAction,
  onChangeCheckInSurveyComments,
  onChangeOrgHealth,
  onChangeOrgHealthChange,
  onFireAnalytics,
  orgMissionChange,
  orgMissionChangeExplanation,
  onSetOrgMissionChange,
  onSetOrgMissionChangeExplanation,
  onSetPriorities,
  onToggleTemplateGoal,
  orgHealthChange,
  orgHealthChangeExplanation,
  priorities,
  userSurvey,
}: WizardConfigArgs): WizardConfig => ({
  [GET_STARTED]: {
    component: (
      <GetStarted
        onAnyAction={onAnyAction}
        onFireAnalytics={onFireAnalytics}
        userSurvey={userSurvey}
      />
    ),
  },
  [REVIEW_PREVIOUS_PRIORITIES]: {
    component: (
      <ReviewPreviousPriorities
        onAnyAction={onAnyAction}
        userSurvey={userSurvey}
      />
    ),
  },
  [REVISIT_YOUR_BASELINES]: {
    component: (
      <RevisitYourBaselines
        onAnyAction={onAnyAction}
        onSetPriorities={onSetPriorities}
        onToggleTemplateGoal={onToggleTemplateGoal}
        priorities={priorities}
      />
    ),
  },
  [YOUR_ORG_MISSION_IMPACT]: {
    component: (
      <YourOrgMissionImpact
        onAnyAction={onAnyAction}
        orgMissionChange={orgMissionChange}
        orgMissionChangeExplanation={orgMissionChangeExplanation}
        onSetOrgMissionChange={onSetOrgMissionChange}
        onSetOrgMissionChangeExplanation={onSetOrgMissionChangeExplanation}
      />
    ),
  },
  [YOUR_ORG_HEALTH]: {
    component: (
      <YourOrgHealth
        onAnyAction={onAnyAction}
        onChangeOrgHealth={onChangeOrgHealth}
        onChangeOrgHealthChange={onChangeOrgHealthChange}
        onFireAnalytics={onFireAnalytics}
        orgHealthChange={orgHealthChange}
        orgHealthChangeExplanation={orgHealthChangeExplanation}
      />
    ),
  },
  [THANK_YOU]: {
    component: (
      <ThankYou
        checkInSurveyComments={checkInSurveyComments}
        onAnyAction={onAnyAction}
        onChangeCheckInSurveyComments={onChangeCheckInSurveyComments}
        userSurvey={userSurvey}
      />
    ),
    hideBackButton: true,
  },
})
